import { useEffect } from 'react';

import { GetServerSideProps } from 'next';
import Head from 'next/head';

import Settings from '~/components/UserDashboard/Settings';
import { Events, DashboardPage } from '~/constants/events';
import Pinchpoints from '~/constants/pinchpoints';
import { trackEvent } from '~/helpers/analytics';
import { useReferralUtmValues } from '~/hooks/useReferralUtmValues';
import { getTranslations } from '~/lib/next-i18next';

const SettingsPage = () => {
  // If the user comes from a referral, we need to set the utm values on the analytics user
  useReferralUtmValues({
    pinchpoint: Pinchpoints.DashboardSettings,
  });

  useEffect(() => {
    trackEvent({
      name: Events.DashboardPageVisited,
      properties: {
        dashboardPageName: DashboardPage.Settings,
      },
    });
  }, []);

  return (
    <>
      <Head>
        <meta name="toucanbot" content="noindex" />
      </Head>
      <Settings />
    </>
  );
};

export default SettingsPage;

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await getTranslations({
        locale,
        namespaces: 'dashboard',
      })),
    },
  };
};
